import {useState} from "react";
import {Login} from "@/components/user/Login";
import {LoginOtpVerify} from "@/components/user/LoginOtpVerify";
import {useAuth} from "@/auth/useAuth";

export default function OtpLoginFlow({style}: { style?: any }) {
    const [otpId, setOtpId] = useState<string>();
    const [email, setEmail] = useState<string>();
    const {requestOTP} = useAuth();

    function onRequestSuccess(id: string, email: string) {
        setOtpId(id);
        setEmail(email);
    }

    function onResend() {
        if (email) {
            requestOTP(email).then(setOtpId);
        }
    }

    function onAbort() {
        setEmail(undefined);
        setOtpId(undefined);
    }

    return (
        <>
            {!otpId && <Login onSuccess={onRequestSuccess} style={style} />}
            {otpId && email && <LoginOtpVerify otpId={otpId} style={style} onResendOtp={onResend} onAbort={onAbort} email={email} />}
        </>
    );
}
